<template>
    <v-dialog v-model="dialogIsOpen" max-width="300" :persistent="true">
        <v-card class="dialog-box home-form-container building_structure_dialog">
            <h2 class="tecnical-local-title">{{itemToEdit ? `${$t('Edit')} ${$tc('TechnicalLocal',1)}` :`${$t('New')} ${$tc('TechnicalLocal',1)}`}}</h2>
            <div class="tecnical-local-form-item">
                <label>{{$t('Phase')}} *</label>
                <treeselect
                    v-model="tecnicalLocal.status"
                    :options="phaseOption"
                    disableFuzzyMatching
                    class="form-input-select vertical-input-select"
                />
            </div>
            <div class="d-flex">
                <div class="tecnical-local-form-item">
                    <label>{{`${$tc('Owner',1)}`}}</label>
                    <treeselect
                        v-model="tecnicalLocal.owner"
                        :options="ownerOptions"
                        disableFuzzyMatching
                        class="form-input-select vertical-input-select"
                    />
                </div>
            </div>      
            <input-field
                :label="`${$tc('Label',1)} *`"
                input-type="text"
                size="large"
                :value="tecnicalLocal.label"
                v-model="tecnicalLocal.label"
            />
            <input-field
                :label="`${$t('Comments')}`"
                input-type="textarea"
                size="large"
                :value="tecnicalLocal.comment"
                v-model="tecnicalLocal.comment"
            />
            <v-card-actions>
                <v-btn
                    @click="$emit('close-tecnical-local-form')"
                    :ripple="false"
                    class="secondary-button"
                    text
                >
                    {{ $t("Cancel") }}
                </v-btn>
                <v-btn
                    :disabled="!objectCanBeCreated"
                    @click="saveTecnicalLocal"
                    :ripple="false"
                    class="main-button"
                    text
                >
                    {{itemToEdit ? $t("Edit") : $t("Create")}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import InputField from "@/components/Home/Forms/_Molecules/InputField";
import { v4 as uuidv4 } from 'uuid';
import { verticalMixin } from "@/mixins/verticalMixin.js";
export default{
    name: "TechnicalLocalForm",
    components: {
        InputField
    },
    mixins: [verticalMixin],
    props:{
        actionType: {
            type: String
        },
        tecnicalLocals: {
            type: Array
        },
        dialogIsOpen: {
            type: Boolean,
            required: true
        },
        itemToEdit: {
            type: Object
        }
    },
    data() {
        return {
            tecnicalLocal: {
                status: null,
                owner: null,
                label: "",
                comment: ""
            },
        }
    },
    computed: {
      /** Indicates if the object can be created */
      objectCanBeCreated() {
        return !!this.tecnicalLocal.label && !!this.tecnicalLocal.status;
      }
    },
    mounted() {
        this.setEditData()
        this.getPhaseOption();
        this.getOwnerOption();
    },
    methods: {
        saveTecnicalLocal(){
            if(!this.itemToEdit){
                this.$emit('add-tecnical-local',
                    {
                        uuid: uuidv4(),
                        network_level: "2",
                        status: this.tecnicalLocal.status,
                        owner : this.tecnicalLocal.owner,
                        label: this.tecnicalLocal.label,
                        comment: this.tecnicalLocal.comment
                    }
                );
            }else{
                this.$emit(
                    'edit-tecnical-local', 
                    {
                        uuid: this.itemToEdit.data.uuid,
                        id: this.itemToEdit.data.id,
                        network_level: "2",
                        status: this.tecnicalLocal.status,
                        owner : this.tecnicalLocal.owner,
                        label: this.tecnicalLocal.label,
                        comment: this.tecnicalLocal.comment
                    }
                    , this.itemToEdit.index
                );
            }
            this.$emit('close-tecnical-local-form');
        },
        setEditData(){
            if(this.itemToEdit){
                this.tecnicalLocal = {
                    status: this.itemToEdit.data.status,
                    owner: this.itemToEdit.data.owner,
                    label: this.itemToEdit.data.label,
                    comment: this.itemToEdit.data.comment
                }

            }
        }
    }

}

</script>
<style scoped>
.tecnical-local-form-item{
    font-family: 'Lato', sans-serif;
    text-align: left;
    font-size: 12px;
}
.tecnical-local-form-item > label{
    padding-left: 5px;
}
.tecnical-local-title{
    color: #42A1B6;
    text-align: start;
    padding-left: 5px;
    margin-bottom: 10px;
}
.input-field{
  padding: 4px 0px !important;
  padding-left: 5px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/TechnicalLocalForm.vue